import { css } from "@emotion/react";
import { CloseButtonSvg2 } from "../../../assets";

export const CloseButton: React.FC<{ onClick: () => void; withEnhandedBackground: boolean }> = ({
  onClick,
  withEnhandedBackground,
}) => {
  return (
    <button
      type={"button"}
      onClick={onClick}
      css={css`
        width: 40px;
        height: 40px;
        padding: 6px;

        right: 8px;
        top: 8px;

        display: block;
        position: absolute;
        z-index: 1;

        border-radius: 8px;

        background: ${withEnhandedBackground ? "rgba(255, 255, 255, 0.5)" : undefined};
      `}
      aria-label="Close"
    >
      <CloseButtonSvg2
        strokeWidth={5}
        css={css`
          // stretch it because svg icon has some whitespace

          width: calc(100% + 10px);
          height: calc(100% + 10px);

          margin-left: -5px;
          margin-top: -5px;
        `}
      />
    </button>
  );
};
